import React, { Fragment } from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";

import SalesModeLayout from "../layout/SalesModeLayout";
import CataloguePage from "../components/catalogue/items";
import CheckoutPos from "../components/catalogue/checkoutPos";
import ChargeItemsProvider from "../components/catalogue/context";
import OrderHistory from "../components/orderHistory";

const SalesModeMainRoute = () => {
    const match = useRouteMatch();
    const { path } = match;

    return (
        <SalesModeLayout>
            <Switch>
                <ChargeItemsProvider>
                    <Fragment>
                        <Route exact path={`${path}/catalogue`}>
                            <CataloguePage />
                        </Route>
                        <Route path={`${path}/catalogue/checkout`}>
                            <CheckoutPos />
                        </Route>
                        <Route path={`${path}/order-history`}>
                            <OrderHistory />
                        </Route>
                    </Fragment>
                </ChargeItemsProvider>
            </Switch>
        </SalesModeLayout>
    );
};

export default SalesModeMainRoute;
